import type { ComponentPropsWithoutRef, ReactElement } from 'react';
import { Spinner } from '@repo/design-system-kit';
import cx from 'clsx';
import styles from './loading.module.css';

type LoadingProps = ComponentPropsWithoutRef<'div'> & {
  spinnerSize?: 'small' | 'medium' | 'large';
};

export function Loading({ spinnerSize, className }: LoadingProps): ReactElement {
  return (
    <div className={cx(styles.loadingContainer, className)} data-testid="loading">
      <Spinner size={spinnerSize} />
    </div>
  );
}
